
import React from 'react'
import "./Mostordered.css"
import PropTypes from "prop-types";
import { Autoplay, Pagination } from 'swiper/modules';
import ProductItem from "../ProductItem/ProductItem"
import { Col, Container, Row } from "react-bootstrap";
import 'swiper/css/pagination';
import 'swiper/css';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// import required modules
import { Navigation } from 'swiper/modules';

function Mostordered({ products }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='mb-5 best_selling_container'>
      <Container>
        <di className="d-flex justify-content-center mb-3">
          <p className='fw-bold fs-5'>{currentLocal.home.mostordered}</p>
          {/* {products.length > 8 &&
            <Link className='text-black' to={"/collections"}>{currentLocal.home.seeMore}</Link>
          } */}
        </di>
        <Container>
          <Row>
            <Swiper
              slidesPerView={3}
              loop={true}

              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                '@0.00': {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                '@0.75': {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                '@1.00': {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                '@1.50': {
                  slidesPerView: 4,
                  spaceBetween: 50,
                },
              }}


              navigation={false}
              modules={[Pagination]}
              className="mySwiper">
              {products?.splice(0, 7)?.map((item, index) => {
                return (
                  <SwiperSlide>
                    <ProductItem
                      product={item}
                    />
                  </SwiperSlide>
                )
              })}
            </Swiper>
            {/* {products?.splice(0, 7)?.map((item, index) => {
              return (
                <Col md={3} key={index}>
                  <ProductItem
                    product={item}
                  />
                </Col>
              )
            })} */}
          </Row>
        </Container>
        {/* <Row>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}
                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}
                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                </Row> */}
      </Container>
    </div>
  )
}

export default Mostordered